import { ComponentChildren, h } from 'preact'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { hasData, isError, isLoading, ResultsState } from '../../../store/state'

import { isParti, Parti, PartiValgResultat, ValgResultat } from '../../../domain'
import { useLocale } from '../../../../lib/intl/IntlProvider'
import { OppslutningLoading } from '../../moduler/OppslutningLoading/OppslutningLoading'
import { Nettverksfeil } from '../../moduler/advarsler/Nettverksfeil/Nettverksfeil'

type ChildFunction = (
  kommuneresultat: PartiValgResultat | ValgResultat,
  currentPage: Parti,
  locale: string
) => ComponentChildren

type Props = {
  currentPage: Parti
  resultat: ResultsState
  children: ChildFunction
}

export function ResultatParti(props: Props) {
  const { resultat, currentPage, children } = props
  const locale = useLocale()
  return (
    <div>
      {hasData(resultat) && children(resultat.data, currentPage, locale)}
      {isLoading(resultat) && <OppslutningLoading grunndata={currentPage} />}
      {isError(resultat) && <Nettverksfeil />}
    </div>
  )
}

type ContainerProps = {
  type: 'auto' | 'fylke' | 'kommune'
  children: ChildFunction
}

export function ResultatParatiContainer(props: ContainerProps) {
  const { kommuneresultat, fylkesresultat, page } = useAppState()
  const currentPage = page.current
  if (!isParti(currentPage)) {
    return null
  }

  return (
    <ResultatParti
      resultat={getResultat(props.type, kommuneresultat, fylkesresultat)}
      currentPage={currentPage}
    >
      {props.children}
    </ResultatParti>
  )
}

function getResultat(
  type: 'auto' | 'kommune' | 'fylke',
  kommuneresultat: ResultsState,
  fylkesresultat: ResultsState
): ResultsState {
  switch (type) {
    case 'auto':
      return kommuneresultat.state !== 'empty' ? kommuneresultat : fylkesresultat
    case 'kommune':
      return kommuneresultat
    case 'fylke':
      return fylkesresultat
    default:
      throw Error(`ResultatContainer fikk en type som ikke er støttet (${type})`)
  }
}
